import {atom} from 'recoil'

export const menuCollapseState = atom({
  key: 'menuCollapseState',
  default: false
})